import {
  HTTP
} from '@/http';

export default class CommonService {
  getCountries() {
    return HTTP.get(`common/countries`);
  }
}



// WEBPACK FOOTER //
// ./src/services/CommonService.js